import { Link } from 'react-router-dom';

export default function HomeCta() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Container%20cargo%20ship%20sailing%20toward%20a%20warm%20sunset%20on%20calm%20ocean%2C%20orange%20and%20amber%20sky%20reflections%20on%20water%2C%20cinematic%20maritime%20logistics%20scene%2C%20soft%20mist%20on%20horizon%2C%20professional%20editorial%20photography%2C%20high%20detail&width=1800&height=900&seq=gls-home-cta&orientation=landscape"
        alt="Fret maritime"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-background-950/70"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4 md:px-10">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/40 text-primary-200 text-xs md:text-sm font-medium tracking-wide uppercase mb-6">
          <i className="ri-ship-line w-4 h-4 flex items-center justify-center"></i>
          Prêt à expédier ?
        </span>
        <h2 className="font-heading text-white text-3xl md:text-5xl font-bold leading-tight">
          Parlons de votre prochain conteneur
        </h2>
        <p className="mt-5 text-white/85 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Décrivez-nous votre besoin et notre équipe revient vers vous sous 24h avec un devis clair et transparent.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/contact" className="px-8 py-3.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white font-semibold whitespace-nowrap cursor-pointer transition inline-flex items-center gap-2">
            Demander un devis gratuit <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
          <Link to="/solutions" className="px-8 py-3.5 rounded-md bg-white/10 hover:bg-white/20 backdrop-blur border border-white/30 text-white font-semibold whitespace-nowrap cursor-pointer transition">
            Voir toutes les solutions
          </Link>
        </div>
      </div>
    </section>
  );
}